module.exports = __webpack_public_path__ + "static/media/mybalogo.f3ac2cc4.png";